import { render, staticRenderFns } from "./activeData.vue?vue&type=template&id=3bca7bac"
import script from "./activeData.vue?vue&type=script&lang=js"
export * from "./activeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bca7bac')) {
      api.createRecord('3bca7bac', component.options)
    } else {
      api.reload('3bca7bac', component.options)
    }
    module.hot.accept("./activeData.vue?vue&type=template&id=3bca7bac", function () {
      api.rerender('3bca7bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/activeData.vue"
export default component.exports